(function () {
  const VERSION = 'MI price clone BEFORE ATC + 77D style + EUR micro-refresh + EUR dedupe + anti-flicker';
  console.log('[MI]', VERSION, 'loaded');

  // Fixed peg: 1 EUR = 1.95583 BGN
  const BGN_PER_EUR = 1.95583;

  const SOURCE_PRICE_SEL = [
    '.js-product-price',
    '[data-product-price]',
    '.product-single__price',
    '.product__price',
    '.price'
  ].join(',');

  /* Inject styling (scoped ONLY to the cloned price near ATC) */
  (function injectMIPriceCSS() {
    if (document.getElementById('mi-price-clone-css')) return;

    const style = document.createElement('style');
    style.id = 'mi-price-clone-css';
    style.textContent = `
      .mi-price-clone-holder{ margin: 18px 0 12px; }

      .mi-price-clone-holder .js-product-price{
        display: flex;
        align-items: baseline;
        gap: 12px;
        flex-wrap: wrap;

        color: #191970;
        font-size: 34px;
        line-height: 1.08;
        font-weight: 500;
        letter-spacing: -0.02em;
      }

      /* EUR styling (2nd span OR our generated span) */
      .mi-price-clone-holder .js-product-price span:nth-of-type(2),
      .mi-price-clone-holder .js-product-price .mi-eur,
      .mi-price-clone-holder .js-product-price [data-mi-eur],
      .mi-price-clone-holder .js-product-price .mi-eur-generated{
        font-size: 16px;
        font-weight: 400;
        line-height: 1.2;
        color: rgba(25,25,112,0.60);
      }

      /* Anti-flicker: hide EUR spans until we decide which one stays */
      .mi-price-clone-holder .js-product-price span.mi-eur-hide{
        display: none !important;
      }

      @media (max-width: 749px){
        .mi-price-clone-holder{ margin: 14px 0 10px; }
        .mi-price-clone-holder .js-product-price{ font-size: 28px; }
        .mi-price-clone-holder .js-product-price span:nth-of-type(2),
        .mi-price-clone-holder .js-product-price .mi-eur,
        .mi-price-clone-holder .js-product-price [data-mi-eur],
        .mi-price-clone-holder .js-product-price .mi-eur-generated{
          font-size: 15px;
        }
      }
    `;
    document.head.appendChild(style);
  })();

  function isVisible(el) {
    return !!(el && el.getClientRects && el.getClientRects().length);
  }

  function findVisibleATCButton() {
    const btns = Array.from(
      document.querySelectorAll('button[type="submit"], button[name="add"], [data-add-to-cart]')
    ).filter(isVisible);

    for (const b of btns) {
      const t = (b.textContent || '').toLowerCase();
      if (t.includes('добави') && (t.includes('колич') || t.includes('cart'))) return b;
    }
    for (const b of btns) {
      const t = (b.textContent || '').toLowerCase();
      if (t.includes('add to cart')) return b;
    }
    return btns[0] || null;
  }

  function getScope(btn) {
    return (
      btn.closest('.product, .product-single, .product__info, .product__info-wrapper, [data-section*="product"]') ||
      btn.closest('section') ||
      document
    );
  }

  function findVisibleSourcePrice(scope) {
    const candidates = Array.from(scope.querySelectorAll(SOURCE_PRICE_SEL))
      .filter(el => el && !el.closest('.mi-price-clone-holder') && isVisible(el));

    for (const el of candidates) {
      const t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t.includes('лв')) return el;
    }
    return candidates[0] || null;
  }

  // Remove IDs from clone to avoid duplicate-id DOM issues
  function stripIds(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.hasAttribute('id')) root.removeAttribute('id');
    root.querySelectorAll('[id]').forEach(n => n.removeAttribute('id'));
  }

  function extractBGNFromText(text) {
    const normalized = (text || '').replace(/\s+/g, ' ').trim();
    const m = normalized.match(/(\d[\d\s.,]*)\s*лв/i);
    return m ? `${m[1].trim()} лв` : '';
  }

  function bgnStringToNumber(bgnStr) {
    const s = (bgnStr || '')
      .replace(/лв/ig, '')
      .replace(/\s+/g, '')
      .trim();
    const n = Number(s.replace(/,/g, ''));
    return isFinite(n) ? n : null;
  }

  function formatEUR_BG(num) {
    const s = num.toLocaleString('bg-BG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return s.replace(/\u00A0/g, '').replace(/\s/g, '');
  }

  /**
   * Hide all EUR spans immediately (prevents flicker),
   * then show only the first EUR and remove the rest.
   */
  function dedupeEURInClonedPrice(holder) {
    const priceNode = holder?.querySelector('.js-product-price');
    if (!priceNode) return;

    const spans = Array.from(priceNode.querySelectorAll('span'));
    const eurSpans = spans.filter(s => (s.textContent || '').includes('€'));

    if (eurSpans.length === 0) return;

    // Hide all EUR instantly (prevents flicker)
    eurSpans.forEach(s => s.classList.add('mi-eur-hide'));

    // Keep ONLY the first EUR visible
    eurSpans[0].classList.remove('mi-eur-hide');

    // Remove other EUR spans
    for (let i = 1; i < eurSpans.length; i++) {
      eurSpans[i].remove();
    }

    // Cleanup loose text nodes that contain € (rare, but can happen)
    Array.from(priceNode.childNodes).forEach(n => {
      if (n.nodeType === 3 && (n.textContent || '').includes('€')) {
        n.textContent = n.textContent.replace(/[\d\s.,]*\s*€/g, '').trim();
      }
    });
  }

  function ensureEURInsideClonedPrice(holder) {
    const priceNode = holder?.querySelector('.js-product-price');
    if (!priceNode) return;

    // If EUR exists, just dedupe (and anti-flicker)
    if ((priceNode.textContent || '').includes('€')) {
      dedupeEURInClonedPrice(holder);
      return;
    }

    // Calculate EUR from BGN and inject as 2nd span
    const bgnText = extractBGNFromText(priceNode.textContent || '');
    const bgnNum = bgnStringToNumber(bgnText);
    if (!bgnText || bgnNum == null) return;

    const eurNum = bgnNum / BGN_PER_EUR;
    const eurText = `${formatEUR_BG(eurNum)} €`;

    const spans = priceNode.querySelectorAll('span');
    const eurSpan = document.createElement('span');
    eurSpan.className = 'mi-eur-generated mi-eur-hide'; // start hidden to avoid flicker
    eurSpan.textContent = eurText;

    if (spans.length >= 1) {
      spans[0].insertAdjacentElement('afterend', eurSpan);
    } else {
      // Normalize to 2 spans if source has no spans
      priceNode.textContent = '';
      const bgnSpan = document.createElement('span');
      bgnSpan.className = 'mi-bgn-text';
      bgnSpan.textContent = bgnText;
      priceNode.appendChild(bgnSpan);
      priceNode.appendChild(eurSpan);
    }

    // Dedupe will show only one EUR and remove the rest
    dedupeEURInClonedPrice(holder);
  }

  function microRefreshEUR(holder) {
    // Run a few times after variant change (Shopify updates asynchronously)
    ensureEURInsideClonedPrice(holder);
    setTimeout(() => ensureEURInsideClonedPrice(holder), 250);
    setTimeout(() => ensureEURInsideClonedPrice(holder), 700);
    setTimeout(() => ensureEURInsideClonedPrice(holder), 1400);
  }

  let scheduled = false;
  let lastSignature = '';

  function ensureCloneBeforeButton() {
    const btn = findVisibleATCButton();
    if (!btn) return;

    const scope = getScope(btn);
    const sourcePrice = findVisibleSourcePrice(scope);
    if (!sourcePrice) return;

    const signature = (sourcePrice.textContent || '').replace(/\s+/g, ' ').trim();
    if (!signature) return;

    const target =
      btn.closest('.product-single__buttons') ||
      btn.closest('.product-form__buttons') ||
      btn.closest('.product-form__submit') ||
      btn;

    if (!target || !target.parentElement) return;

    let holder = target.parentElement.querySelector(':scope > .mi-price-clone-holder');
    if (!holder) {
      holder = document.createElement('div');
      holder.className = 'mi-price-clone-holder';
      target.parentElement.insertBefore(holder, target);
    }

    if (signature === lastSignature && holder.firstChild) {
      microRefreshEUR(holder);
      return;
    }

    const clone = sourcePrice.cloneNode(true);
    stripIds(clone);

    // IMPORTANT: insert clone, then immediately dedupe EUR to prevent flicker
    holder.innerHTML = '';
    holder.appendChild(clone);

    // Hide/dedupe EUR immediately (same frame)
    dedupeEURInClonedPrice(holder);

    lastSignature = signature;

    // Ensure EUR exists (calculate if Shopify didn't inject it), with retries
    microRefreshEUR(holder);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      ensureCloneBeforeButton();
    });
  }

  function boot() {
    schedule();

    const obs = new MutationObserver(schedule);
    obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

    document.addEventListener('change', schedule, true);
    document.addEventListener('click', schedule, true);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
